import gql from "graphql-tag";

export default gql`query Upload($id:Int!) {
    upload(id:$id) {
        id
        uploadDescription {
            id
            body
        }
      }
  }`